const validateSelectPlan = (values, errors) => {
    if (!values.enrollment.selectPlan.plan) {
        errors.enrollment.selectPlan.plan = 'Please select a plan to continue';
    }
};
export default validateSelectPlan;
